import React, { useMemo } from 'react';
import Card from '@mui/material/Card';
import NumberFormat from "react-number-format";
import TextField from '@mui/material/TextField';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
// import { Box } from '@mui/system';
import Grid from '@mui/material/Grid';
import {Typography, Button, MenuItem, Box} from '@mui/material';
import Colors from "../../components/ui/Colors";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import Divider from '@mui/material/Divider';
import {createWarehouseLabel, getWarehouseCodes, discardProductBatch, enableBatch, getPendingBatches, disableBatch} from "../../utilityFunctions/WarehouseUtil.js";
import { PuffLoader } from "react-spinners";
import { css } from "@emotion/react";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import swal from 'sweetalert';
import moment from 'moment';
import 'moment/locale/es';

const cssLoader = css`
  display: block;
  margin-left: auto;
  margin-right: auto;
`;

const dateOptions = {
    // weekday: "short",
    day: "numeric",
    month: "numeric",
    year: "numeric",
};

const qrDateOptions = {
    day: "numeric",
    month: "numeric",
    year: "numeric",
    hour: 'numeric',
    minute: 'numeric',
}

const qrRequest = {
    level: "",
    barCode: "",
    individual: 0,
    date: null,
    plant: "planta 1",
};

let newLabelBatch;

const disableRequest = {};


export default function LabelGenerator(props) {

    const {loginUser, warehouseProducts} = props;

    const [loading, setLoading] = React.useState(false);

    const plants = ["planta 1", "planta 2"];

    React.useEffect(() => {
        // getProductsCodes();
        const handlePendingBatches = async () => {
            setLoading(true);
            await fetchPendingBatches();
            setLoading(false);
        }

        handlePendingBatches();
    }, []);

    const [pendingBatches, setPendingBatches] = React.useState([]);

    const fetchPendingBatches = async () => {
        if(loginUser.roles && !(Object.keys(loginUser.roles).length === 0 && loginUser.roles.constructor === Object) && (loginUser.roles.some((rol) => rol.authority === "SUPERVISOR") || loginUser.roles.some((rol) => rol.authority === "ADMIN"))){
            const batches = await getPendingBatches(loginUser.jwtToken);
            setPendingBatches(batches);
            console.log(batches);
        }
    }
    

    const [barcode, setBarcode] = React.useState("");
    const [codes, setCodes] = React.useState("");
    const [level, setLevel] = React.useState("");
    const [individual, setIndividual] = React.useState(0);
    const [description, setDescription]= React.useState(null);
    const [plant, setPlant] = React.useState("");
    const barcodeChange = (e) => {
        setBarcode(e.target.value);
        qrRequest.barCode=e.target.value;

        const productFound = warehouseProducts && warehouseProducts.find((el) => el.barCode === e.target.value);

        if(productFound){
            setDescription(productFound.description);
        }
    }

    const levelChange = (e) => {
        setLevel(e.floatValue);
        qrRequest.level = e.floatValue;
        console.log("level change...");
    };

    const individualChange = (e) => {
        setIndividual(e.floatValue);
        qrRequest.individual = e.floatValue;
    };

    const plantChange = (e) => {
        setPlant(e.target.value);
        qrRequest.plant = e.target.value;
    };

    const [qrImg, setQrImg] = React.useState("");

    const generateQr = async () => {
        setLoading(true);
        const qrResponse = await createWarehouseLabel(qrRequest, loginUser.jwtToken);
        setLoading(false);

        setLevel("");
        setIndividual(0);
        setSelectedDate(null);
        setBarcode("");
        setDescription(null);
        setPlant("");
        
        if(!qrResponse){
            return;
        };

        setQrImg(qrResponse.qrImageBytes);

        newLabelBatch=qrResponse.productBatch;
        

    };

    React.useEffect(()=> {
        if(qrImg){
            setQrBox(true);
        }
    }, [qrImg]);

    const[qrBox, setQrBox] = React.useState(false);

    const closeQrBox = () => {
        setQrBox(false);
    };

    const notConfirmedLabel = async () => {

        const deleteObject={
            id: newLabelBatch.id,
        }

        setLoading(true);
        const deletedBatch= await discardProductBatch(deleteObject, loginUser.jwtToken);
        setLoading(false);

        setLevel("");
        setIndividual(0);
        setSelectedDate(null);
        setBarcode("");
        setDescription(null);
        setPlant("");

        closeQrBox(true);
    };
            
    const handleBatchActivation = async () => {


        const activateRequest = {
            id: newLabelBatch.id,
        }
        await enableBatch(activateRequest, loginUser.jwtToken);

        await fetchPendingBatches();

    };  

    const handlePrint = () => {

        //Activate the current QR and disabled the pending ones
        handleBatchActivation();

        //Open a new window to print the QR as soon as the button is clicked to avoid the popup blocker
        const printWindow = window.open('', '_blank');
        const imageUrl = URL.createObjectURL(qrImg);
        
        // Modern approach instead of document.write
        const printDocument = printWindow.document;
        
        printDocument.open();
        
        const html = `
         <html>
            <head>
                <title>Print Label</title>
                <style>
                    @media print { 
                        @page { size: landscape; } 
                    }
                    * {
                        margin: 0;
                        padding: 0;
                        box-sizing: border-box;
                    }
                    body {
                        margin: 15px 0 0 0;
                        padding: 0;
                    }
                    .description-paragraph { 
                        font-size: 44px; 
                        font-weight: bold; 
                        margin: 0 0 5px 0;
                    }
                    .label-paragraph { 
                        font-size: 34px;
                        margin-bottom: 5px;
                    }
                    .subtitle-paragraph { 
                        font-size: 32px; 
                        margin: 0;
                    }
                    .register-paragraph { 
                        font-size: 40px;
                        font-weight: bold; 
                        margin: 0;
                    }
                    .date-paragraph { 
                        font-size: 26px; 
                        margin-bottom: 0;
                    }
                    .product-paragraph { 
                        font-size: 50px; 
                        font-weight: bold; 
                        margin: 5px 0;
                    }
                    .plant-paragraph { 
                        font-size: 40px; 
                        font-weight: bold; 
                        margin: 5px 0;
                    }
                    .nutiron-paragraph { 
                        font-size: 44px; 
                        font-weight: bold; 
                        margin: 0;
                    }
                    .container { 
                        display: flex; 
                        flex-direction: column;
                    }
                    .row { 
                        display: flex; 
                        width: 100%;
                    }
                </style>
            </head>
            <body>
                <div class="container">
                    <!-- First row: 70% + 30% -->
                    <div class="row">
                        <div style="width: 70%; margin-left: 30px; margin-top: 10px;">
                        </div>
                        <div style="width: 30%;">
                            <div style="text-align: end; margin-right: 20px; margin-top: 10px;">
                                <p class="date-paragraph">${new Intl.DateTimeFormat('es-CO', qrDateOptions).format(new Date(Date.now()))}</p>
                            </div>
                        </div>
                    </div>

                    <!-- Second row: 100% width -->
                    <div class="row" style="margin-top: 5px; text-align: center;">
                        <div style="width: 100%;">
                            <p class="product-paragraph">${newLabelBatch.warehouseProduct.description}</p>
                            <p class="plant-paragraph">${newLabelBatch.plant}</p>
                        </div>
                    </div>

                    <!-- Third row: 20% + 60% + 20% -->
                    <div class="row">
                        <div style="width: 20%; margin-top: 70px; margin-left: 50px;">
                            <p class="label-paragraph">Cantidad:</p>
                            <p class="description-paragraph">${new Intl.NumberFormat('es-CO').format(newLabelBatch.productAmount)}</p>
                            <p class="label-paragraph">Lote:</p>
                            <p class="description-paragraph">${newLabelBatch.batchCode}</p>
                        </div>
                        <div style="width: 60%; display: flex; justify-content: center; align-items: center;">
                            <img id="qrImage" src="${imageUrl}" alt="QR" style="width: 95%; height: auto; margin-top: 40px;">
                        </div>
                        <div style="width: 20%; margin-top: 70px; margin-right: 15px;">
                            <p class="label-paragraph">Estiba No:</p>
                            <p class="description-paragraph">${newLabelBatch.id}</p>
                            <p class="label-paragraph">Vencimiento:</p>
                            <p class="description-paragraph">${new Intl.DateTimeFormat('es-CO', dateOptions).format(new Date(newLabelBatch.expirationDate))}</p>
                        </div>
                    </div>
                </div>
            </body>
         </html>
         `;
        
        printDocument.write(html);
        printDocument.close();
        
        const imgElement = printDocument.querySelector('img');
        imgElement.onload = () => {
          for (let i = 0; i < 2; i++) {
            printWindow.print();
          }
          printWindow.close();
        };
      
        closeQrBox();
    };
      

    const [selectedDate, setSelectedDate] = React.useState(null);

    const handleDateChange = (date) => {
        setSelectedDate(moment(date).format('YYYYMMDD'));
        qrRequest.date=moment(date).format('YYYYMMDD');
    };

    const handleDisableBatch = async () => {
        setLoading(true);
        
        const disabledBatch = await disableBatch(disableRequest, loginUser.jwtToken);
        closeDisableConfirmationBox();
        
        if(!disabledBatch){
            swal({
                title: "Error",
                text: "No se pudo desactivar la estiba. Vuelva a intentarlo",
                icon: "error",
            });
            return;
        };

        swal({
            title: "Éxito",
            text: "Estiba desactivada correctamente",
            icon: "success",
        });

        await fetchPendingBatches();
        setLoading(false);
    };

    const[disableConfirmationBox, setDisableConfirmationBox] = React.useState(false);

    const closeDisableConfirmationBox = () => {
        setDisableConfirmationBox(false);
        disableRequest.batchId = "";
    };

    const openDisableConfirmationBox = (batch) => {
        setDisableConfirmationBox(true);
        disableRequest.batchId = batch.id;
    };

    // Memoize the sorted batches list so it doesn't recalculate on every render
    const sortedBatches = useMemo(() => {
        return pendingBatches
            .slice()
            .sort((a, b) => a.id - b.id);
    }, [pendingBatches]);

    return (
        <Box sx={{display: "flex", justifyContent: "center",  width: "100%", height: "100%", backgroundColor: "#ededed",}}>
            <Box
            sx={{
                display: "flex",
                // flex: 1,
                justifyContent: "center",
                alignItems: {xs: "center", sm: "center", md: "center"},
                width: "90%",
                height: "100%",
                textAlign: "center",
            }}
            >
            {loading ? <PuffLoader size={100} color={Colors.secondary} css={cssLoader} /> :
            <>
                <Grid container sx={{display: "flex", justifyContent: {xs: "center", sm: "center"}, alignItems: "center", width: "100%", height: "100%"}}>
                    <Grid item xs={6} sm={8} md={8} sx={{
                        display: "flex", 
                        justifyContent: "center", 
                        alignItems: "center",
                        height: "80%", 
                        maxHeight: "80%", 
                        overflow: "visible" // Allow card to be fully visible
                    }}>
                        <Card sx={{maxWidth: "400px", minWidth: {xs: "90%", sm: "90%", md: "300px"}, borderRadius: "15px"}}>
                            <Grid container>
                                <Grid item xs={12} sm={12} md={12} sx={{display: "flex", justifyContent: "center", alignItems: "center", marginTop: "1rem"}}>
                                    <TextField
                                        sx={{width: "80%"}}
                                        variant="standard"
                                        fullWidth={true}
                                        id="barcode"
                                        name="barcode"
                                        label={<Typography variant="body2">Código Producto</Typography>}
                                        value={barcode}
                                        onChange={(e)=> barcodeChange(e)}
                                        autoComplete="off"
                                    />
                                </Grid>
                                {description &&
                                    <>
                                    <Grid item xs={12} sm={12} md={12} sx={{display: "flex", justifyContent: "start", alignItems: "center", marginTop: "1.3rem", marginLeft: "10%"}}>
                                        <Typography sx={{color: "gray", fontSize: "0.6rem"}}>Producto</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} sx={{display: "flex", justifyContent: "start", alignItems: "center", marginLeft: "10%"}}>
                                        <Typography variant="body1">{`${description}`}</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} sx={{marginBottom: "1rem", marginLeft: "10%"}}>
                                        <Divider sx={{width: "90%"}} />
                                    </Grid>
                                    </>
                                }
                                {/* <Grid item xs={12} sm={12} md={12} sx={{display: "flex", justifyContent: "center", alignItems: "center", marginTop: "1rem", marginBottom: "1rem"}}>
                                    <NumberFormat
                                        variant="standard"
                                        style={{width: "80%", height: "90%"}}
                                        name="level"
                                        customInput={TextField}
                                        // prefix={'$ '}
                                        type="level"
                                        label={<Typography variant="body2">Niveles</Typography>}
                                        thousandSeparator={'.'}
                                        decimalSeparator={','}
                                        autoComplete="off"
                                        value={level}
                                        onValueChange={(values) => {
                                            levelChange(values);
                                        }}
                                    />
                                </Grid> */}
                                <Grid item xs={12} sm={12} md={12} sx={{display: "flex", justifyContent: "center", alignItems: "center", marginTop: "1rem", marginBottom: "1rem"}}>
                                    <NumberFormat
                                        variant="standard"
                                        style={{width: "80%", height: "90%"}}
                                        name="individual"
                                        customInput={TextField}
                                        // prefix={'$ '}
                                        type="individual"
                                        label={<Typography variant="body2">Unidades</Typography>}
                                        thousandSeparator={'.'}
                                        decimalSeparator={','}
                                        autoComplete="off"
                                        value={individual}
                                        onValueChange={(values) => {
                                            individualChange(values);
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} sx={{display: "flex", justifyContent: "center", alignItems: "center", marginTop: "1rem", marginBottom: "1rem"}}>
                                    <TextField
                                        sx={{
                                            width: "80%",
                                            "& .MuiSelect-select": {
                                                textAlign: "left",
                                                fontSize: "0.875rem"
                                            }
                                        }}
                                        variant="standard"
                                        select
                                        label={<Typography variant="body2">Planta</Typography>}
                                        value={plant}
                                        onChange={(e) => plantChange(e)}
                                    >
                                        {plants.map((plant) => (
                                            <MenuItem key={plant} value={plant}>{plant}</MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} sx={{width: "100%", marginTop: "0.5rem"}}>
                                    <LocalizationProvider dateAdapter={AdapterMoment}>
                                        <DesktopDatePicker
                                            timezone="America/Bogota"
                                            locale="es" 
                                            label={<Typography variant="body2">Fecha de producción</Typography>}
                                            inputFormat="DD/MM/YYYY"
                                            value={selectedDate}
                                            onChange={handleDateChange}
                                            renderInput={(params) => 
                                                <TextField {...params} 
                                                    variant="standard"
                                                    fullWidth
                                                    sx={{width: {xs: "90%", sm: "80%", md: "80%"}}}
                                                />}
                                        />
                                    </LocalizationProvider>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12}>
                                    <Button onClick={generateQr} variant="contained" sx={{backgroundColor: Colors.primary, marginTop: "2rem", marginBottom: "2rem"}}>
                                        Generar
                                    </Button>
                                </Grid>
                            </Grid>
                        </Card>
                    </Grid>
                    {loginUser.roles && !(Object.keys(loginUser.roles).length === 0 && loginUser.roles.constructor === Object) && (loginUser.roles.some((rol) => rol.authority === "SUPERVISOR") || loginUser.roles.some((rol) => rol.authority === "ADMIN")) &&
                        <Grid item xs={6} sm={4} md={4} sx={{width: "100%", height: "80%", display: "flex", justifyContent: "center", alignItems: "start"}}>
                            <Grid container direction="column" sx={{width: "100%", height: "100%"}}>
                                <Grid item sx={{display: "flex", justifyContent: "center", alignItems: "start", height: "10%"}}>
                                    <Typography variant="h5" sx={{fontWeight: "bold"}}>Estibas Pendientes</Typography>
                                </Grid>
                                <Grid item sx={{
                                    display: "flex", 
                                    justifyContent: "center", 
                                    alignItems: "start", 
                                    overflow: "hidden", 
                                    height: "90%", 
                                    maxHeight: "calc(100vh - 200px)",
                                    textAlign: "center"
                                }}>
                                    <List sx={{
                                        width: "100%", 
                                        height: "100%", 
                                        maxHeight: "100%", 
                                        overflow: "auto", 
                                        textAlign: "center"
                                    }}>
                                        {sortedBatches.map((batch, index) => (
                                            <ListItem key={index} divider sx={{marginBottom: "1rem", textAlign: "center"}}>
                                                <ListItemButton 
                                                    onClick={() => openDisableConfirmationBox(batch)}
                                                    sx={{
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'flex-start',
                                                        padding: '8px 16px',
                                                        borderBottom: '1px solid #eaeaea'
                                                    }}
                                                >
                                                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                                                        {batch.id}
                                                    </Typography>
                                                    <Typography variant="body2" sx={{ color: 'text.primary' }}>
                                                        {new Intl.DateTimeFormat('es-CO', dateOptions).format(new Date(batch.date))}
                                                    </Typography>
                                                    <Typography variant="body2" sx={{ color: 'text.secondary', textAlign: 'left', width: '100%', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                        {batch.warehouseProduct?.description || 'Sin descripción'}
                                                    </Typography>
                                                    <Typography variant="body2" sx={{ color: 'text.primary' }}>
                                                        Cantidad: {new Intl.NumberFormat('es-CO').format(batch.productAmount || 0)}
                                                    </Typography>
                                                </ListItemButton>
                                            </ListItem>
                                        ))}
                                    </List>
                                </Grid>
                            </Grid>
                        </Grid>
                    }
                </Grid>

                <Dialog open={qrBox} onClose={closeQrBox}>
                    
                    {qrImg && newLabelBatch &&
                    <Grid container>
                        <Grid item xs={12} sm={12} md={12} sx={{display: "flex", alignItems: "center", justifyContent: "center", marginTop: "0.1rem", width: "100%"}}>
                            <Box 
                                component="img"
                                sx={{
                                height: "90%",
                                // maxHeight: "200px",
                                width: "90%",
                                justifyContent: "center",
                                }}
                                alt="QR"
                                src={URL.createObjectURL(qrImg)}

                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} sx={{display: "flex", alignItems: "center", justifyContent: "center", width: "100%", marginBottom: "1rem"}}>
                            <Grid container sx={{width: {xs: "70%", sm: "60%", md: "50%"}, display: "flex", justifyContent: "center"}}>
                                <Grid item xs={12} sm={12} md={12} sx={{display: "flex", alignItems: "center", justifyContent: "center", marginTop: "1rem", width: "100%"}}>
                                    <Typography variant = "body2">{`${newLabelBatch.warehouseProduct.description}`}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} sx={{display: "flex", alignItems: "center", justifyContent: "center", marginTop: "1rem", width: "100%"}}>
                                    <Typography variant = "body2">{`Código: ${newLabelBatch.id}`}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} sx={{display: "flex", alignItems: "center", justifyContent: "center", marginTop: "1rem", width: "100%"}}>
                                    <Typography variant = "body2">{`Lote: ${newLabelBatch.batchCode}`}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} sx={{display: "flex", alignItems: "center", justifyContent: "center", marginTop: "1rem", width: "100%"}}>
                                    <Typography variant = "body2">{`Cantidad: ${new Intl.NumberFormat('es-CO').format(newLabelBatch.productAmount)}`}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} sx={{display: "flex", alignItems: "center", justifyContent: "center", marginTop: "1rem", width: "100%"}}>
                                    <Typography variant = "body2">{`Vencimiento: ${new Intl.DateTimeFormat('es-CO', dateOptions).format(new Date(newLabelBatch.expirationDate))}`}</Typography>
                                </Grid>
                            </Grid> 
                        </Grid>
                    </Grid>
                    }
                    
                    <DialogActions sx={{display: "flex", justifyContent: "center"}}>
                        <Button onClick={handlePrint} variant="contained" sx={{backgroundColor: Colors.primary,}}>
                            Confirmar
                        </Button>
                        <Button onClick={notConfirmedLabel} variant="contained" sx={{backgroundColor: Colors.primary,}}>
                            Descartar
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* Disable confirmation box */}
                <Dialog open={disableConfirmationBox} onClose={closeDisableConfirmationBox}
                    sx={{
                        "& .MuiDialog-container": {
                            "& .MuiPaper-root": {
                                width: {xs: "80%", sm: "50%", md: "40%"},
                                height: "20%"
                            },
                        },
                    }}
                >
                    <Grid container>
                        <Grid item xs={12} sm={12} md={12} sx={{display: "flex", justifyContent: "center", textAlign: "center", mt: "1rem", mb: "2.5rem"}}>
                            <Typography variant="h6">{`Desactivación estiba: ${disableRequest.batchId}`}</Typography>
                        </Grid>
                        <Grid item xs={6} sx={{display: "flex", justifyContent: "center"}}>
                            <Button onClick={closeDisableConfirmationBox} variant="contained" sx={{backgroundColor: Colors.primary,}}>
                                Atrás
                            </Button>
                        </Grid>
                        <Grid item xs={6} sx={{display: "flex", justifyContent: "center"}}>
                            <Button onClick={handleDisableBatch} variant="contained" sx={{backgroundColor: Colors.primary,}}>
                                Confirmar
                            </Button>
                        </Grid>
                    </Grid>
                </Dialog>
            
            </>
            }
            </Box>
        </Box>
    )
}
